module.exports = __webpack_public_path__ + "static/media/hiroba_logo.db28470e.svg";